// extracted by css-extract-rspack-plugin
export default {"LectureTypeLabel":"EGehp"};